export var AssistantType;
(function (AssistantType) {
    AssistantType[AssistantType["ACCOUNT_VIEWER"] = 100] = "ACCOUNT_VIEWER";
    AssistantType[AssistantType["INFO_VIEWER"] = 101] = "INFO_VIEWER";
    AssistantType[AssistantType["REPORT_VIEWER"] = 102] = "REPORT_VIEWER";
    AssistantType[AssistantType["CUSTOM_VIEWER"] = 103] = "CUSTOM_VIEWER";
})(AssistantType || (AssistantType = {}));
//# sourceMappingURL=AssistantType.js.map